import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import { Grid, Button, Typography } from '@material-ui/core';
import { actions as userActions } from 'store/user';
const { logout } = userActions;

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  },
  content: {
    paddingTop: 150,
    textAlign: 'center'
  },
  image: {
    marginTop: 50,
    display: 'inline-block',
    maxWidth: '100%',
    width: 560
  },
  resetButton: {
    width: '20%',
    justifyItems: 'center'
  },
  buttonContainer: {
    textAlign: 'center'
  }
}));

const LicenseNotFound = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const { licenseFailed, errorOccurred } = useSelector(store => store.user);

  const goToSign = () => {
    dispatch(logout());
    history.push('/sign-in');
  };

  return (
    <div className={classes.root}>
      <Grid container justify="center" spacing={4}>
        <Grid item lg={6} xs={12}>
          <div className={classes.content}>
            <Typography variant="h1">Unauthorized Access</Typography>
            {licenseFailed && (
              <Typography variant="subtitle2">
                User is not licensed to access this resource.
              </Typography>
            )}
            {errorOccurred && (
              <Typography variant="subtitle2">
                Error occured in accessing this resource.
              </Typography>
            )}
            {!licenseFailed && !errorOccurred && (
              <Typography variant="subtitle2">
                User is not authorized to access this resource.
              </Typography>
            )}
            <img
              alt="License Required"
              className={classes.image}
              src="images/unauthorized.png"
            />
          </div>
          {!licenseFailed && !(window.self !== window.top) && ( //Condition for finding iFrame
            <div className={classes.buttonContainer}>
              <Button
                className={classes.resetButton}
                color="primary"
                fullWidth
                size="large"
                type="submit"
                variant="contained"
                onClick={goToSign}>
                GO TO SIGN IN
              </Button>
            </div>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default LicenseNotFound;
